module.exports = __webpack_public_path__ + "img/primary_10x1_z16.635979e9.svg";